import { proxy, ref } from "valtio";

const storeModel = {
  camTargetsObject: ref({}),
  hideBackground: false,
};

export const powerrailProductStore = proxy(storeModel);
